import {
  GET_EVENT_DETAILS,
  GET_EVENT_DETAILS_SUCCESS,
  GET_EVENT_DETAILS_FAIL,
  SAVE_OWNER_DETAILS,
  SAVE_OWNER_DETAILS_SUCCESS,
  SAVE_OWNER_DETAILS_FAIL,
  REMOVE_CO_OWNER,
  REMOVE_CO_OWNER_SUCCESS,
  REMOVE_CO_OWNER_FAIL,
  SAVE_EVENT_NAME,
  SAVE_EVENT_NAME_SUCCESS,
  SAVE_EVENT_NAME_FAIL,
  VALIDATE_EVENT_NAME,
  VALIDATE_EVENT_NAME_SUCCESS,
  VALIDATE_EVENT_NAME_FAIL,

} from './actions';

const initialState = {
  loaded: false,
  loading: true,
  editing: {},
  saveError: {},
  userEventDetails: {},
  saveOwnerdata: [],
  removeCoOwnerData: [],
  eventNameData: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_EVENT_DETAILS:
      return {
        ...state,
      };
    case GET_EVENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        userEventDetails: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_EVENT_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case SAVE_OWNER_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case SAVE_OWNER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        saveOwnerdata: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case SAVE_OWNER_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case REMOVE_CO_OWNER:
      return {
        ...state,
        userEventDetails: {
          ...state.userEventDetails,
          eventDetailsInfo: {
            ...state.userEventDetails.eventDetailsInfo,
            celebrityInfo: action.payload,
          },
        },
      };
    case REMOVE_CO_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        removeCoOwnerData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case REMOVE_CO_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case SAVE_EVENT_NAME:
      return {
        ...state,
        userEventDetails: {
          ...state.userEventDetails,
          eventDetailsInfo: {
            ...state.userEventDetails.eventDetailsInfo,
            eventName: action.payload,
          },

        },
      };
    case SAVE_EVENT_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        eventNameData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case SAVE_EVENT_NAME_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case VALIDATE_EVENT_NAME:
      return {
        ...state,
        loading: true,
      };
    case VALIDATE_EVENT_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case VALIDATE_EVENT_NAME_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
